import React, { useState, useEffect } from "react";
import fetchData from "../../api/fetchApi";
import InternationalPhoneField from "../forms/InternationalPhoneField";
import { isInternationalPhoneValid, phoneForApi } from "../../utils/phone";

export default function UserManagementPage() {
  const [form, setForm] = useState({
    username: "",
    name: "",
    email: "",
    phone: "",
    birthday: "",
    role: "",
    password: "",
  });
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [search, setSearch] = useState("");
  const [selectedUserIdx, setSelectedUserIdx] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  // Pagination and users state
  const [users, setUsers] = useState([]);
  const [page, setPage] = useState(1);
  const [perPage] = useState(10);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  // Fetch users from API
  useEffect(() => {
    setLoading(true);
    fetchData(`/admin/users?page=${page}&per_page=${perPage}`)
      .then((res) => {
        setUsers(res.users || []);
        setTotal(res.total || 0);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [page, perPage]);

  const handleChange = (e) => {
    setForm((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleAddUser = async (e) => {
    e.preventDefault();
    if (
      !form.username ||
      !form.name ||
      !form.email ||
      !form.username ||
      !form.name ||
      !form.email ||
      !form.phone ||
      !form.birthday ||
      !form.role ||
      !form.password
    ) {
      setError("يرجى تعبئة جميع الحقول");
      setSuccess("");
      return;
    }
    if (!isInternationalPhoneValid(form.phone)) {
      setError("رقم الهاتف غير صالح. اختر الدولة وتحقق من الرقم.");
      setSuccess("");
      return;
    }
    setError("");
    setSuccess("");
    try {
      // You may need to provide branch_uuid from context or another source
      const branch_uuid = "6b34e67d4ac94f2e8e58640928de16d0"; // Set this appropriately
      const payload = {
        username: form.username,
        password: form.password,
        name: form.name,
        role: form.role,
        phone_number: phoneForApi(form.phone),
        birthday: form.birthday,
        branch_uuid,
        
      };
      const res = await fetchData("/admin/user",
        "POST",
 JSON.stringify(payload),
      );
      if (res && res.username) {
        setSuccess("تمت إضافة المستخدم بنجاح!");
        setForm({
          username: "",
          name: "",
          email: "",
          phone: "",
          birthday: "",
          role: "",
          password: "",
        });
        // Optionally, refresh users list
        setPage(1);
      } else {
        setError("حدث خطأ أثناء إضافة المستخدم");
      }
    } catch (err) {
      setError("حدث خطأ أثناء إضافة المستخدم");
    }
  };

  // Filter users by search (username, name, phone_number)
  const filteredUsers = users.filter(
    (user) =>
      user.username?.includes(search) ||
      user.name?.includes(search) ||
      user.phone_number?.includes(search)
  );

  // Example action functions
  const handleDisableAccount = () => {
    if (selectedUserIdx === null) return;
    alert(`تعطيل الحساب: ${filteredUsers[selectedUserIdx].username}`);
  };
  const handleChangeName = () => {
    if (selectedUserIdx === null) return;
    alert(`تغيير الاسم: ${filteredUsers[selectedUserIdx].username}`);
  };
  const handleChangePassword = () => {
    if (selectedUserIdx === null) return;
    alert(`تعديل كلمة المرور: ${filteredUsers[selectedUserIdx].username}`);
  };

  return (
    <div className="mx-auto bg-white  p-8 rounded-xl shadow mt-8">
      <h2 className="text-2xl font-extrabold mb-4 text-gray-800  flex items-center gap-2">
        إدارة المستخدمين
      </h2>
      <p className="text-gray-600  mb-4">
        يمكنك إضافة مستخدمين جدد وإدارة معلوماتهم من هنا.
      </p>
      <form onSubmit={handleAddUser} className="space-y-4 mb-10">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block mb-1 font-medium">اسم المستخدم</label>
            <input
              type="text"
              name="username"
              className="w-full border rounded px-3 py-2"
              value={form.username}
              onChange={handleChange}
              required
              placeholder="اسم المستخدم"
            />
          </div>
          <div>
            <label className="block mb-1 font-medium">الاسم الكامل</label>
            <input
              type="text"
              name="name"
              className="w-full border rounded px-3 py-2"
              value={form.name}
              onChange={handleChange}
              required
              placeholder="الاسم الكامل"
            />
          </div>
          <div>
            <label className="block mb-1 font-medium">البريد الإلكتروني</label>
            <input
              type="email"
              name="email"
              className="w-full border rounded px-3 py-2"
              value={form.email}
              onChange={handleChange}
              required
              placeholder="البريد الإلكتروني"
            />
          </div>
          <div>
            <InternationalPhoneField
              id="admin-user-phone"
              label="رقم الهاتف"
              name="phone"
              value={form.phone}
              onChange={(phone) => setForm((current) => ({ ...current, phone }))}
              required
              placeholder="رقم الهاتف"
            />
          </div>
          <div>
            <label className="block mb-1 font-medium">تاريخ الميلاد</label>
            <input
              type="date"
              name="birthday"
              className="w-full border rounded px-3 py-2"
              value={form.birthday}
              onChange={handleChange}
              required
              placeholder="تاريخ الميلاد"
            />
          </div>
          <div>
            <label className="block mb-1 font-medium">الدور</label>
            <select
              name="role"
              className="w-full border rounded px-3 py-2"
              value={form.role}
              onChange={handleChange}
              required
            >
              <option value="">اختر الدور</option>
              <option value="superadmin">مدير</option>
              <option value="admin">مشرف</option>
           
            </select>
          </div>
          <div>
            <label className="block mb-1 font-medium">كلمة المرور</label>
            <input
              type="password"
              name="password"
              className="w-full border rounded px-3 py-2"
              value={form.password}
              onChange={handleChange}
              required
              placeholder="كلمة المرور"
            />
          </div>
        </div>
        {error && <div className="text-red-600 mb-2">{error}</div>}
        {success && <div className="text-green-600 mb-2">{success}</div>}
        <button
          type="submit"
          className="w-full bg-[#013D4E] text-white py-2 rounded hover:bg-indigo-700"
        >
          إضافة مستخدم
        </button>
      </form>

      <h3 className="text-xl font-bold mb-4 text-[#013D4E] ">
        قائمة المستخدمين
      </h3>
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-4 gap-2">
        <div className="relative">
          <button
            className="bg-gray-700  text-white px-4 py-2 rounded flex items-center gap-2 hover:bg-gray-800 "
            onClick={() => setDropdownOpen(!dropdownOpen)}
          >
            <span>عمليات</span>
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path d="M19 9l-7 7-7-7" />
            </svg>
          </button>
          {dropdownOpen && (
            <div className="absolute left-0 mt-2 w-48 bg-white  border  rounded shadow-lg z-10">
              <ul>
                <li
                  className="px-4 py-2 hover:bg-gray-100  cursor-pointer flex items-center gap-2"
                  onClick={handleDisableAccount}
                >
                  تعطيل الحساب
                  <span>🔌</span>
                </li>
                <li
                  className="px-4 py-2 hover:bg-gray-100  cursor-pointer flex items-center gap-2"
                  onClick={handleChangeName}
                >
                  <span>تغيير الاسم</span>
                  <span>🔄</span>
                </li>
                <li
                  className="px-4 py-2 hover:bg-gray-100  cursor-pointer flex items-center gap-2"
                  onClick={handleChangePassword}
                >
                  <span>تعديل كلمة المرور</span>
                  <span>🔑</span>
                </li>
              </ul>
            </div>
          )}
        </div>
        <div className="flex items-center gap-2">
          <div className="text-sm text-gray-700 ">
            عدد البيانات:{" "}
            <span className="text-yellow-600 font-bold">
              {total}
            </span>
          </div>
          <input
            type="text"
            placeholder="بحث"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="border rounded px-3 py-1 w-32 sm:w-48 focus:outline-none bg-gray-50  "
          />
        </div>
      </div>
      <div className="rounded shadow p-4 bg-white  overflow-x-auto">
        {loading ? (
          <div className="text-center py-8 text-gray-500">جاري التحميل...</div>
        ) : (
          <table className="w-full text-right border-collapse">
            <thead>
              <tr className="bg-gray-100 ">
                <th className="py-2 px-3"></th>
                <th className="py-2 px-3 text-gray-700 ">
                  اسم المستخدم
                </th>
                <th className="py-2 px-3 text-gray-700 ">
                  الاسم الكامل
                </th>
                <th className="py-2 px-3 text-gray-700 ">
                  رقم الهاتف
                </th>
                <th className="py-2 px-3 text-gray-700 ">
                  تاريخ الميلاد
                </th>
                <th className="py-2 px-3 text-gray-700 ">
                  الحالة
                </th>
                <th className="py-2 px-3 text-gray-700 ">
                  الجلسة
                </th>
                <th className="py-2 px-3 text-gray-700 ">
                  الحصة
                </th>
              </tr>
            </thead>
            <tbody>
              {filteredUsers.length === 0 ? (
                <tr>
                  <td colSpan={8} className="text-center py-4 text-gray-500">
                    لا يوجد مستخدمون.
                  </td>
                </tr>
              ) : (
                filteredUsers.map((user, idx) => (
                  <tr
                    key={user.uuid}
                    className={`border-t  ${
                      selectedUserIdx === idx ? "bg-indigo-50 " : ""
                    }`}
                    onClick={() => setSelectedUserIdx(
                      selectedUserIdx === idx ? null : idx
                    )}
                    style={{ cursor: "pointer" }}
                  >
                    <td className="py-2 px-3">
                      <input
                        type="checkbox"
                        checked={selectedUserIdx === idx}
                        onChange={() => setSelectedUserIdx(
                          selectedUserIdx === idx ? null : idx
                        )}
                        onClick={(e) => e.stopPropagation()}
                      />
                    </td>
                    <td className="py-2 px-3">{user.username}</td>
                    <td className="py-2 px-3">{user.name}</td>
                    <td className="py-2 px-3">{user.phone_number}</td>
                    <td className="py-2 px-3">{user.birthday ? new Date(user.birthday).toLocaleDateString() : ""}</td>
                    <td className="py-2 px-3">{user.status}</td>
                    <td className="py-2 px-3">
                      {user.sessions && user.sessions.length > 0
                        ? (
                          <span className={`px-2 py-1 rounded text-xs ${
                            user.sessions[0].status === "connected"
                              ? "bg-green-100 text-green-700"
                              : user.sessions[0].status === "pending"
                              ? "bg-yellow-100 text-yellow-700"
                              : "bg-gray-100 text-gray-700"
                          }`}>
                            {user.sessions[0].name} ({user.sessions[0].status})
                          </span>
                        )
                        : "-"}
                    </td>
                    <td className="py-2 px-3">
                      {user.quota
                        ? `${user.quota.used_total}/${user.quota.limit}`
                        : "-"}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        )}
        {/* Pagination controls */}
        <div className="flex justify-center items-center gap-2 mt-4">
          <button
            className="px-3 py-1 rounded bg-gray-200  text-gray-700  disabled:opacity-50"
            onClick={() => setPage((p) => Math.max(1, p - 1))}
            disabled={page === 1}
          >
            السابق
          </button>
          <span className="mx-2 text-gray-700 ">
            صفحة {page} من {Math.ceil(total / perPage) || 1}
          </span>
          <button
            className="px-3 py-1 rounded bg-gray-200  text-gray-700  disabled:opacity-50"
            onClick={() => setPage((p) => (p < Math.ceil(total / perPage) ? p + 1 : p))}
            disabled={page >= Math.ceil(total / perPage)}
          >
            التالي
          </button>
        </div>
      </div>
    </div>
  );
}
